import React from 'react';

export const config = {
  ip: '',
  setIp: () => {},
};

export const AppContext = React.createContext(config);
